import { ControllerInterface } from "csi/action/Controller";
import reflection from "csi/reflection";
import { C8Node } from "csi/typings";
import { ILocaleProvider } from "designSystem/locale";
import RecipeLabelStore from "./Recipe/RecipeLabelStore";

/** create recipe label store */
export async function createRecipeLabelStore(document: C8Node, loc: ILocaleProvider, actionController: ControllerInterface, operation: string): Promise<RecipeLabelStore> {
	const currCache = actionController.m_cache;
	let userSettings = [];
	if (operation === "RecipeUpdateFoodLabelDataSheet") {
		// Updating Recipe Data Sheet
		const recipeFoodLabelChild = currCache.getChildNode(actionController.getNode(), "RecipeFoodLabel", true);
		userSettings = reflection.getNodeSetting(recipeFoodLabelChild, "DataSheetSections");
	} else if (operation === "FoodBOMUpdateLabelDataSheet") {
		// Updating Food BOM Label Data Sheet
		const foodBOMLabelChild = currCache.getChildNode(actionController.getNode(), "BOMLabelDataSheet", true);
		if (foodBOMLabelChild) {
			userSettings = reflection.getNodeSetting(foodBOMLabelChild, "DataSheetSections");
		}
	}
	
	const store = new RecipeLabelStore(document, loc, userSettings, operation);
	return store;
}
